import styled from 'styled-components'

const PageContainerHorizontalMargin = styled.div`
  margin: 0 5%;
`

export default PageContainerHorizontalMargin
